import "./Footer.css";

export const Footer = () => {
  return <div className="footer">MND_CNTRL ⓒ 2024</div>;
};
